import React, { PropsWithChildren, useState } from "react";

import Grid from "@material-ui/core/Grid";
import { DateTimePicker } from '@material-ui/pickers';

import { ActionFilterButtonWithDialog, ApartmentBoxPreview, GqlRecordPicker } from "../../../components";
import useReservationFilterStyle from './reservation_filters.style';
import { Amenity, Apartment } from "../../../../graphql/models";
import { QUERIES } from '../../../../graphql';
import { Checkbox } from "@material-ui/core";

export type ReservationFilterValue = {
  from: Date;
  to: Date;
  amenity?: Amenity;
  apartments?: Apartment[];
  excludeDeleted?: boolean;
}

export interface ReservationFiltersProps extends PropsWithChildren<{}> {
  value: ReservationFilterValue;
  setValue: (v: ReservationFilterValue) => void;
}

function ReservationFilters(props: ReservationFiltersProps) {
  const { value, setValue, children } = props;

  const classes = useReservationFilterStyle();

  const [from, setFrom] = useState<Date>(value.from);
  const [to, setTo] = useState<Date>(value.to);
  const [amenity, setAmenity] = useState<Amenity | undefined>(value.amenity);
  const [apartments, setApartments] = useState<Apartment[] | undefined>(value.apartments);
  const [includeDeleted, setIncludeDeleted] = useState<boolean>(false);

  const onConfirmClick = () => {
    setValue({
      ...value,
      from,
      to,
      amenity,
      apartments,
      excludeDeleted: !includeDeleted
    });
  }

  return <ActionFilterButtonWithDialog
    onConfirmClick={onConfirmClick}
  >
    <Grid container spacing={3}>
      <Grid item sm={4} xs={12}>
        <DateTimePicker
          ampm={false}
          clearable={false}
          format="dd/MM/yyyy HH:mm"
          className={classes.fullWidth}
          label="Dal"
          inputVariant="outlined"
          value={from}
          onChange={(e) => setFrom(e as Date)}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <DateTimePicker
          ampm={false}
          clearable={false}
          format="dd/MM/yyyy HH:mm"
          className={classes.fullWidth}
          label="Al"
          inputVariant="outlined"
          value={to}
          onChange={(e) => setTo(e as Date)}
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <GqlRecordPicker
          className={classes.fullWidth}
          multiple={false}
          value={amenity}
          getOptionLabel={(record) => record.name}
          placeHolder={'Amenity'}
          renderOption={(record) => record.name}
          onValueChange={(value) => setAmenity(value)}
          query={QUERIES.AMENITIES}
          queryResultDataField={'amenities'}
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <GqlRecordPicker
          className={classes.fullWidth} 
          multiple={true}
          value={apartments}
          getOptionLabel={(record: Apartment) => [record.building?.name, record.code, record.name, record.owner?.name].filter(v => Boolean(v)).join('-')}
          placeHolder={'Appartamenti'}
          renderOption={(record: Apartment) => (
            <ApartmentBoxPreview
              apartment={record}
            />
          )}
          onValueChange={(value) => setApartments(value)}
          query={QUERIES.APARTMENTS}
          queryResultDataField={'apartments'}
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Checkbox 
          checked={includeDeleted}
          onChange={(evt, val) => setIncludeDeleted(val)}
        />
        Includi le prenotazioni che sono state annullate?
      </Grid>
    </Grid>
    {children}
  </ActionFilterButtonWithDialog>
}

export { ReservationFilters }
